export const SearchTypeAttributeHistory = 200 as const;
export type TSearchTypeAttributeHistory = typeof SearchTypeAttributeHistory;
